import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PageStatusService } from 'src/app/services/page-status.service';
import { User } from '@mocca-technologies/model';


import { droneMoccaIcon } from 'src/assets/icons';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
})
export class UserMenuComponent  implements OnInit {
  droneMoccaIcon = droneMoccaIcon;

  user: User = JSON.parse(localStorage.getItem('user'));

  @Input() smallSizeButton?: boolean = false;

  constructor(
    private router: Router,
    private pageStatusService: PageStatusService
  ) { }

  ngOnInit() {}

  isHomePage(): boolean {
    return this.pageStatusService.isHomePage;
  }

  navigateToHome(){
    this.router.navigateByUrl('/operations', {replaceUrl: true});
  }
}
